const cartForm = document.querySelector("#cartform");

function quantityLinkClicked(event, target) {
    event.preventDefault();
    updateFromLink(target.href);
}
function quantityChanged(event, target) {
    updateFromLink(`${window.theme.routes.cart_change_url}?quantity=${target.value}&line=${target.getAttribute("data-line")}`);
}
async function rerenderCart(_refreshCartContents,_cartCount){
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = _refreshCartContents;
    setTimeout(async () => {
        const cartFormUpdated = fakeDiv.querySelector("#cartform");
        if(cartFormUpdated){
            // Cart has item
            document.querySelector("#cartform .cart-list").innerHTML = cartFormUpdated.querySelector(".cart-list").innerHTML;
            document.querySelector("#cartform #cart-total-price").innerHTML = cartFormUpdated.querySelector("#cart-total-price").innerHTML;

            cartForm.classList.remove("cart--loading");

            // ★追加：紙袋・メッセージカードのみになっていないかチェック
            await checkGiftOnlyCart();
        }else{
            // Cart is empty
            document.querySelector(`[data-section-type="cart-template"]`).innerHTML = `
                <h1 data-cc-animate="" class="h2 cc-animate-init -in cc-animate-complete">カート</h1>
                <div>
                    <div class="rte cc-animate-init -in cc-animate-complete" data-cc-animate="" data-cc-animate-delay="0.4s" style="">
                    <p data-cc-animate="" data-cc-animate-delay="0.2s" class="align-center cc-animate-init -in cc-animate-complete" style="">
                        カートに商品がありません
                    </p>
                    <p class="align-center"><a data-cc-animate-click="" href="/collections/%E5%95%86%E5%93%81%E4%B8%80%E8%A6%A7">買い物を続ける</a></p>
                    </div>
                </div>
            `;
        }

        if(_cartCount){
            document.querySelector("#header-cart-count").innerHTML = _cartCount;
        }
    }, 0);
}
async function updateFromLink(link) {
    cartForm.classList.add("cart--loading");
    const changeUrl = new URL(link, `https://${window.theme.routes.host}`), searchParams = changeUrl.searchParams, line = searchParams.get("line"), id = searchParams.get("id"), quantity = parseInt(searchParams.get("quantity"));
    const response = await fetch(`${window.theme.routes.cart_change_url}.js`, {
        body: JSON.stringify({ line, id, quantity, sections: ["main-cart"] }),
        credentials: "same-origin",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        }
    });
    const cartContent = await response.json();

    if(cartContent?.sections["main-cart"]){
        let refreshCartContents = cartContent?.sections["main-cart"],
            cartCount = cartContent?.item_count;

        const updateFormData = {updates :  {} , sections: ["main-cart"] }; 

        const w3ParentCartItems = cartContent?.items.filter(item => item.properties?._options_group_id && !item.properties?._options_hidden);
        if(w3ParentCartItems.length > 0){
            w3ParentCartItems.forEach(w3Item => {
                const itemCount = w3Item.quantity;
                const w3ItemOptions = cartContent?.items.filter(
                    item => item.properties?._options_group_id === w3Item.properties?._options_group_id
                    && item.key !== w3Item.key
                    && item.quantity !== itemCount
                );
    
                if(w3ItemOptions.length > 0){
                    w3ItemOptions.forEach(optionItem => {
                        updateFormData.updates[optionItem.key] = itemCount;
                    });
                }
            });
        }
        const w3ChildCartItems = cartContent?.items.filter(item => item.properties?._options_group_id && item.properties?._options_hidden === "true");
        if(w3ChildCartItems.length > 0){
            w3ChildCartItems.forEach(optionItem => {
                const optionParent = w3ParentCartItems.find(item => optionItem.properties?._options_group_id ===  item.properties?._options_group_id);
                if(!optionParent){
                    updateFormData.updates[optionItem.key] = 0;
                }
            });
        }

        if(Object.keys(updateFormData.updates).length > 0){
            const response = await fetch(`${window.theme.routes.cart_update_url}.js`, {
                body: JSON.stringify(updateFormData),
                credentials: "same-origin",
                method: "POST",
                headers: {
                "Content-Type": "application/json"
                }
            });
            const updatedCartContent = await response.json();
            refreshCartContents = updatedCartContent?.sections["main-cart"];
            cartCount = updatedCartContent?.item_count;
        }

        rerenderCart(refreshCartContents,cartCount);
    }else{
        console.error("error");
        location.reload();
        cartForm.classList.remove("cart--loading");
    }
}

/* ============================================================
   ★追加：紙袋・メッセージカードのみのカートを検知して全削除
   window.GIFT_ONLY_IDS はカートセクション(Liquid)から渡される
   ============================================================ */

let giftOnlyProcessing = false;

function showGiftOnlyLoading() {
    if (document.getElementById('gift-only-loading-overlay')) return;
    const overlay = document.createElement('div');
    overlay.id = 'gift-only-loading-overlay';
    overlay.innerHTML = `
        <div class="gift-only-loading__box">
            <div class="gift-only-loading__spinner"></div>
            <p class="gift-only-loading__text">カートを更新しています…</p>
        </div>`;
    document.body.appendChild(overlay);
}

async function checkGiftOnlyCart() {
    if (giftOnlyProcessing) return;

    const ids = window.GIFT_ONLY_IDS || [];
    if (ids.length === 0) return;

    let cart;
    try {
        cart = await (await fetch('/cart.js')).json();
    } catch (e) {
        console.error('カート情報の取得に失敗しました', e);
        return;
    }

    if (!cart.items || cart.items.length === 0) return;

    const hasNonGift = cart.items.some(item => !ids.includes(item.product_id));
    if (hasNonGift) return;

    giftOnlyProcessing = true;

    alert('紙袋・メッセージカードのみがカートに入っています。これらの商品は単体で購入できないため、カート内の商品を削除します。');
    showGiftOnlyLoading();

    try {
        await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    } catch (e) {
        console.error('カートのクリアに失敗しました', e);
    } finally {
        window.location.replace('/cart');
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkGiftOnlyCart);
} else {
    checkGiftOnlyCart();
}